/**
 * Safely access sessionStorage
 */
export const safeSessionGet = (key: string): string | null => {
    try {
        return sessionStorage.getItem(key)
    } catch (_err) {
        return null
    }
}

/**
 * Safely access localStorage
 */
export const safeLocalGet = (key: string): string | null => {
    try {
        return localStorage.getItem(key)
    } catch (_err) {
        return null
    }
}

/**
 * Safely set sessionStorage
 */
export const safeSessionSet = (key: string, value: string): boolean => {
    try {
        sessionStorage.setItem(key, value)

        return true
    } catch (_err) {
        return false
    }
}

/**
 * Safely set localStorage
 */
export const safeLocalSet = (key: string, value: string): boolean => {
    try {
        localStorage.setItem(key, value)

        return true
    } catch (_err) {
        return false
    }
}

/**
 * Try to find and remove auth-related items from storage
 */
export const cleanAuthRelatedItems = (storage: Storage): void => {
    try {
        for (let i = 0; i < storage.length; i++) {
            const key = storage.key(i)

            if (key && (key.includes('auth') || key.includes('token'))) {
                storage.removeItem(key)
            }
        }
    } catch (_err) {
        // Silently handle errors
    }
}

/**
 * Common auth storage keys to clear during logout or switching profiles
 */
export const AUTH_STORAGE_KEYS = {
    local: [
        'auth-storage',
        'accessToken',
        'refreshToken',
        'firstName',
        'lastName',
        'email',
        'cellphone'
    ],
    session: [
        'agent-auth-storage',
        'accessToken',
        'refreshToken',
        'agent-firstName',
        'agent-lastName',
        'agent-email',
        'agent-cellphone'
    ]
}
